import { useEffect, useRef, useState } from 'react'

const CATEGORIES = [
  '💎 Natural Astrological Gemstones',
  '📿 Energized Yantras & Talismans',
  '🌿 Authentic Rudraksha Combinations',
  '🔥 Customized Planetary Puja Kits',
]

export default function RemedyModal({ open, onClose }) {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [category, setCategory] = useState(CATEGORIES[0])
  const [nameFocus, setNameFocus] = useState(false)
  const [phoneFocus, setPhoneFocus] = useState(false)
  const [categoryFocus, setCategoryFocus] = useState(false)
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [confirmShown, setConfirmShown] = useState(false)
  const timersRef = useRef([])

  useEffect(() => () => timersRef.current.forEach(window.clearTimeout), [])

  const handleSubmit = (e) => {
    e.preventDefault()
    onClose()
    setName('')
    setPhone('')
    setCategory(CATEGORIES[0])

    setConfirmShown(true)
    const t1 = window.setTimeout(() => setConfirmVisible(true), 30)
    const t2 = window.setTimeout(() => setConfirmVisible(false), 5000)
    const t3 = window.setTimeout(() => setConfirmShown(false), 5300)
    timersRef.current.push(t1, t2, t3)
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          background: 'rgba(0,0,0,.75)',
          backdropFilter: 'blur(10px)',
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',
          transition: 'opacity .3s',
        }}
        onClick={onClose}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            maxWidth: '400px',
            maxHeight: '90vh',
            overflowY: 'auto',
            background: 'linear-gradient(160deg,#FEFCF8 0%,#FAF4E8 100%)',
            border: '1px solid rgba(200,146,42,.22)',
            borderRadius: '24px',
            padding: '30px',
            boxShadow: '0 28px 80px rgba(0,0,0,.55)',
            transform: open ? 'scale(1)' : 'scale(.95)',
            transition: 'transform .3s',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: 'rgba(28,10,3,.06)',
              border: '1px solid rgba(200,146,42,.16)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '17px',
              color: '#8B6914',
              cursor: 'pointer',
              transition: 'background .22s',
              lineHeight: 1,
            }}
            onMouseOver={(e) => { e.currentTarget.style.background = 'rgba(200,146,42,.12)' }}
            onMouseOut={(e) => { e.currentTarget.style.background = 'rgba(28,10,3,.06)' }}
          >
            ×
          </button>

          <div style={{ textAlign: 'center', marginBottom: '18px' }}>
            <div
              style={{
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg,rgba(200,146,42,.13),rgba(200,146,42,.05))',
                border: '1px solid rgba(200,146,42,.28)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '19px',
                margin: '0 auto 10px',
              }}
            >
              🔮
            </div>
            <h3 className="font-royal font-bold" style={{ fontSize: '16px', color: '#1C0A03', marginBottom: '3px' }}>
              Request Remedy Guidance
            </h3>
            <p style={{ fontSize: '11px', color: '#8B7355' }}>Get gemstone recommendations verified for your horoscope</p>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '8px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.2em', color: '#8B7355', marginBottom: '5px' }}>
                Your Name
              </label>
              <input
                type="text"
                required
                placeholder="Enter your full name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={() => setNameFocus(true)}
                onBlur={() => setNameFocus(false)}
                style={{
                  width: '100%',
                  background: 'rgba(28,10,3,.04)',
                  border: `1.5px solid ${nameFocus ? 'rgba(200,146,42,.52)' : 'rgba(200,146,42,.16)'}`,
                  borderRadius: '12px',
                  padding: '10px 14px',
                  fontSize: '13px',
                  color: '#1C0A03',
                  outline: 'none',
                  transition: 'border-color .22s',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '8px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.2em', color: '#8B7355', marginBottom: '5px' }}>
                WhatsApp / Phone
              </label>
              <input
                type="tel"
                required
                placeholder="+91 98765 43210"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                onFocus={() => setPhoneFocus(true)}
                onBlur={() => setPhoneFocus(false)}
                style={{
                  width: '100%',
                  background: 'rgba(28,10,3,.04)',
                  border: `1.5px solid ${phoneFocus ? 'rgba(200,146,42,.52)' : 'rgba(200,146,42,.16)'}`,
                  borderRadius: '12px',
                  padding: '10px 14px',
                  fontSize: '13px',
                  color: '#1C0A03',
                  outline: 'none',
                  transition: 'border-color .22s',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '8px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.2em', color: '#8B7355', marginBottom: '5px' }}>
                Remedy Category
              </label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                onFocus={() => setCategoryFocus(true)}
                onBlur={() => setCategoryFocus(false)}
                style={{
                  width: '100%',
                  background: '#FEFCF8',
                  border: `1.5px solid ${categoryFocus ? 'rgba(200,146,42,.52)' : 'rgba(200,146,42,.16)'}`,
                  borderRadius: '12px',
                  padding: '10px 14px',
                  fontSize: '13px',
                  color: '#5C3A18',
                  outline: 'none',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box',
                  appearance: 'none',
                  transition: 'border-color .22s',
                }}
              >
                {CATEGORIES.map((c) => (
                  <option key={c}>{c}</option>
                ))}
              </select>
            </div>
            <button type="submit" className="gs-cta-btn" style={{ width: '100%', padding: '11px', fontSize: '9px', marginTop: '3px' }}>
              Submit Inquiry
              <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </button>
          </form>
        </div>
      </div>

      {confirmShown && (
        <div
          style={{
            position: 'fixed',
            bottom: '24px',
            left: '24px',
            zIndex: 99999,
            background: '#FEFCF8',
            border: '1.5px solid rgba(200,146,42,.38)',
            color: '#5C3A18',
            fontSize: '12px',
            fontWeight: 600,
            padding: '14px 22px',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(28,10,3,.14)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            opacity: confirmVisible ? 1 : 0,
            transform: confirmVisible ? 'translateY(0)' : 'translateY(8px)',
            transition: 'all .3s',
            maxWidth: '340px',
            fontFamily: 'inherit',
          }}
        >
          <span style={{ fontSize: '20px' }}>✨</span>
          <span>Your inquiry has been received! Our remedy expert will contact you via WhatsApp shortly.</span>
        </div>
      )}
    </>
  )
}
